<template>
    <div class="flex input-group">
        <slot></slot>
    </div>
</template>

<script>
export default {
    //
}
</script>

<style scoped>
    .input-group > :not(:last-child) > *:not(:focus) {
        @apply rounded-r-none border-r-transparent;
    }
    .input-group > :not(:last-child) > *:focus {
        @apply rounded-r-none overflow-visible relative z-10;
    }
    .input-group > :not(:first-child) > *:not(:focus) {
        @apply rounded-l-none border-l-transparent;
    }
    .input-group > :not(:first-child) > *:focus {
        @apply rounded-l-none overflow-visible relative z-10;
    }
</style>

  